module.exports = __webpack_public_path__ + "img/home_new_1.8260b4d4.jpg";